import React, { useContext } from 'react';
import { Journey, PageAbsolutePath } from '../../consts/Common';
import PageInfoPlanSummary from './PageInfoPlanSummary';
import PageInfoProduct from './PageInfoProduct';
import './PageInfo.scss';
import PageInfoCreatePlan from './PageInfoCreatePlan';
import PageInfoVehicle from './PageInfoVehicle';
import UsefulDocuments from './UsefulDocuments';
import { SiteContext } from '../../context/SiteContext';
import { DocumentView } from '../common/Constants';
import { DocumentTreeItem, ProductType } from '../common/CommonTypes';

type PageInfoProps = {
  documents: DocumentTreeItem[];
  expandedDocIds: string[];
  products: ProductType[];
  currentPath: string;
  setExpandedDocIds: (docIds: string[]) => void;
};

const PageInfo = ({
  documents,
  expandedDocIds,
  products,
  currentPath,
  setExpandedDocIds
}: PageInfoProps): JSX.Element => {
  const { site } = useContext(SiteContext);
  const cms = site.content;

  const isCCWUser: boolean =
    site.journeyType === Journey.Customer && !!site.user?.userId;

  const pageInfoSummaryClass = isCCWUser
    ? 'desktop-content page-info-container sticky-content'
    : 'desktop-content sticky-content';

  switch (currentPath) {
    case PageAbsolutePath.VehicleDetails:
    case PageAbsolutePath.Customer.VehicleDetails:
      return (
        <div className='desktop-content page-info-container sticky-content'>
          <PageInfoVehicle showReasonsToProtect={!isCCWUser} />
          {!isCCWUser && (
            <UsefulDocuments
              documents={[]}
              cmsDocuments={cms.usefulDocuments}
              view={DocumentView.Desktop}
              expandedDocIds={expandedDocIds}
              setExpandedDocIds={setExpandedDocIds}
              showDivider={!isCCWUser}
            />
          )}
        </div>
      );
    case PageAbsolutePath.Products:
    case PageAbsolutePath.Customer.Products:
      return (
        <div className='desktop-content page-info-container sticky-content'>
          <PageInfoProduct showReasonsToProtect={!isCCWUser} />
          <UsefulDocuments
            documents={documents}
            cmsDocuments={cms.usefulDocuments}
            view={DocumentView.Desktop}
            expandedDocIds={expandedDocIds}
            setExpandedDocIds={setExpandedDocIds}
            showDivider={!isCCWUser}
          />
        </div>
      );
    case PageAbsolutePath.CreatePlan:
    case PageAbsolutePath.Customer.CreatePlan:
      return (
        <div className='desktop-content page-info-container sticky-content'>
          <PageInfoCreatePlan showReasonsToProtect={!isCCWUser} />
          <UsefulDocuments
            documents={documents}
            cmsDocuments={cms.usefulDocuments}
            view={DocumentView.Desktop}
            expandedDocIds={expandedDocIds}
            setExpandedDocIds={setExpandedDocIds}
            showDivider={true}
          />
        </div>
      );
    case PageAbsolutePath.Customer.PersonalDetails:
    case PageAbsolutePath.PersonalDetails:
    case PageAbsolutePath.Summary:
    case PageAbsolutePath.Customer.Summary:
    case PageAbsolutePath.DirectDebit:
    case PageAbsolutePath.Customer.DirectDebit:
    case PageAbsolutePath.Customer.SinglePayment:
    case PageAbsolutePath.SinglePayment:
      return (
        <div className={pageInfoSummaryClass}>
          {!isCCWUser && cms.common?.hideCustomerPlan !== true && (
            <PageInfoPlanSummary
              products={products}
              culture={site.cultureCode}
            />
          )}
          <div className='m2-left'>
            <UsefulDocuments
              documents={documents}
              cmsDocuments={cms.usefulDocuments}
              view={DocumentView.Desktop}
              expandedDocIds={expandedDocIds}
              setExpandedDocIds={setExpandedDocIds}
              showDivider={false}
            />
          </div>
        </div>
      );
    case PageAbsolutePath.Confirmation:
    case PageAbsolutePath.Customer.Confirmation: {
      return (
        <div className='desktop-content-full'>
          <img
            className='landing-image'
            src={cms.confirmationPage.backgroundImageUrl}
            alt='confirmation page image'
          />
        </div>
      );
    }
    default:
      return <div className='desktop-content sticky-content'></div>;
  }
};

export default PageInfo;
